import { Component, OnInit } from '@angular/core';

@Component({
    templateUrl: './assigned-manufacturers.component.html',
    styleUrls: ['./assigned-manufacturers.component.scss'],
    standalone: false
})
export class AssignedManufacturersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
